import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import './css/index.css';
import Landing from './Landing';
import Hangon from './Hangon';
import Partners from './Partners';
import registerServiceWorker from './registerServiceWorker';

const Root = () => {
  return (
      <Router>
      	<div>
	        <Route exact path="/" component={Landing}/>
	        <Route path="/hangon" component={Hangon}/>
          <Route path="/partners" component={Partners}/>
        </div>
      </Router>
  )
}

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js